import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle2 } from 'lucide-react';
export function BenefitStackSection() {
  const benefits = [{
    title: 'Secure hold for up to 3 days',
    desc: 'Forget about your dentures for days at a time.'
  }, {
    title: 'Eat confidently again',
    desc: 'Enjoy steak, apples, and corn on the cob without fear.'
  }, {
    title: 'No messy pastes or powders',
    desc: 'Say goodbye to the sticky, gross residue of old adhesives.'
  }, {
    title: 'Gentle, smooth comfort',
    desc: 'Prevents sore spots and gum irritation instantly.'
  }, {
    title: 'Speak and laugh freely',
    desc: 'No more clicking sounds or slipping while talking.'
  }, {
    title: 'Feel like yourself again',
    desc: 'Restore your dignity and confidence immediately.'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-1">
      <div className="container mx-auto px-4 md:px-6" data-id="element-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-3">
          <div className="order-2 lg:order-1" data-id="element-4">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-8 font-serif leading-tight" data-id="element-5">
              Why 50,000+ Denture Wearers Trust Dentafix™
            </h2>

            <div className="grid grid-cols-1 gap-6 mb-10" data-id="element-6">
              {benefits.map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-7">
                  <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-1" data-id="element-8" />
                  <div data-id="element-9">
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-10">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-11">{benefit.desc}</p>
                  </div>
                </div>)}
            </div>

            <CTAButton text="Get Dentafix™ With Free Shipping" data-id="element-12" />
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-13">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-14">
              <img src="https://images.unsplash.com/photo-1529543544282-ea99407407c1?w=800&q=80" alt="Family dinner happiness" className="w-full h-[600px] object-cover" data-id="element-15" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-16">
                <div className="absolute bottom-8 left-8 right-8 text-white" data-id="element-17">
                  <p className="text-2xl font-serif font-bold mb-2" data-id="element-18">
                    "I finally ate steak again!"
                  </p>
                  <p className="opacity-90" data-id="element-19">
                    Enjoying meals with family is priceless.
                  </p>
                </div>
              </div>
            </div>

            {/* Floating Badge */}
            <div className="absolute top-8 -left-8 bg-white p-4 rounded-lg shadow-xl hidden md:block transform -rotate-3" data-id="element-20">
              <p className="font-bold text-red-600 text-lg" data-id="element-21">#1 Rated</p>
              <p className="text-gray-600 text-sm" data-id="element-22">Comfort Solution</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}